import React,{useState,useContext,useEffect} from 'react'
import { ProductContext } from './Productcontext';
import thor_ico from '../images/lightningcategory/thor_icon.svg';

import clp_ico from '../images/lightningcategory/clp_icon.svg';
import ele_ico from '../images/lightningcategory/electrode_icon.svg';
import bfc_ico from '../images/lightningcategory/bfc_icon.svg';
import epcc_ico from '../images/lightningcategory/epcc_icon.svg';
//import {useNavigate } from 'react-router-dom';
import { useRouter } from 'next/navigation';
import Image from 'next/image';
const ProductsubMenu = () => {
    //let navigate = useNavigate();
    const router = useRouter();
    const { selectedCategory,setCategory } = useContext(ProductContext);
    const [selectedItem, setSelectedItem] = useState(selectedCategory);

       // this for menu or fotter active item manage
       const [activeItem, setActiveItem] = useState(() => {
        if (typeof window !== 'undefined') {
          return localStorage.getItem('activeItem') || null;
        }
        return null;
      });
    
      // Update activeItem in localStorage whenever it changes
      useEffect(() => {
        if (activeItem) {
          localStorage.setItem('activeItem', activeItem);
          setSelectedItem(activeItem);
          setCategory(activeItem);
          console.log("get catgory"+activeItem);
        }
      //  console.log("use effect active item="+activeItem);
      }, [activeItem,setActiveItem]);


    const handleItemClick = (item) => {
        setSelectedItem(item);
        //onImageClick(item); // Call the function passed as prop with the clicked item
        setCategory(item);
        localStorage.setItem('activeItem', item);
        //console.log(" catgory setedd" +selectedCategory);
        localStorage.setItem('selectedCategory', item);
        //  navigate('/lpcat')
        //router.push('/lpcat')
         console.log(" catgory setedd =" + item);
         console.log(" catgory setedd =" + localStorage.getItem('activeItem'));
       if(item==='slpr')
        router.push('/ashlok-lightning-protection-systems')
        else if(item==='clp')
            router.push('/ashlok-conventional-lightning-protection')
        else if(item==='bfc')
            router.push('/ashlok-baron-backfill-compound')
        else if(item==='epcc')
            router.push('/ashlok-earthpit-chamber-cover')
       else if(item==='ele')
        router.push('/ashlok-safe-earthing-electrodes')
       localStorage.setItem('activeItem', item);
      };
    
    //   useEffect(() => {
    //     setSelectedItem(selectedCategory);
    //     }, [selectedCategory]);

    useEffect(() => {
        const storedItem = localStorage.getItem('selectedCategory');
        if (storedItem) {
            setSelectedItem(storedItem);
            setCategory(storedItem);
            localStorage.setItem('activeItem', storedItem);
            //setProduct(storedItem);
        }
        if (activeItem) {
            localStorage.setItem('activeItem', activeItem);
            setCategory(activeItem);
          }

    }, [selectedCategory,setCategory,activeItem, setActiveItem]);

    return (
    <div className=' w-full bg-ashblack flex '>
        <div className=' container mx-auto flex  flex-col lg:flex-row  justify-start lg:justify-center  items-start lg:items-center'>
            <div className={`w-full lg:w-1/5 h-18 flex flex-row   justify-start  lg:justify-center   items-center  ml-1 mr-1 cursor-pointer hover:cursor-pointer ${selectedItem === 'slpr'  ? 'bg-ashred' : ''}`} onClick={() => handleItemClick('slpr')}>
                <div  className='h-20 flex items-center justify-center px-4 w-14'><Image src={thor_ico} alt="Thor SLPR Air Terminal by Ashlok Safe Earthing Electrode Limited"/></div>
                <div  className=''><p className=' text-base text-white'>Safe Lightning Protection Rod(s)</p></div>
            </div>
            <div className={`w-full lg:w-1/5 h-18 px-1 flex flex-row  justify-start  lg:justify-center items-center  ml-1 mr-1 cursor-pointer hover:cursor-pointer ${selectedItem   === 'clp' ? 'bg-ashred' : ''}`} onClick={() => handleItemClick('clp')}>
                <div  className='h-20 flex items-center justify-start px-4 w-12'><Image src={clp_ico} alt="Conventional Lightning Protection Systems and Earthing Rod by Ashlok Safe Earthing Electrode Limited"/></div>
                <div  className=''><p className=' text-base text-white'>Conventional Lightning Protection</p></div>
            </div>
            <div className={`w-full lg:w-1/5 h-18 flex flex-row  justify-start  lg:justify-center items-center  ml-1 mr-1 cursor-pointer hover:cursor-pointer ${selectedItem === 'ele'   ? 'bg-ashred' : ''}`} onClick={() => handleItemClick('ele')}>
                <div  className='h-20 flex items-center justify-center  px-4 w-14'><Image src={ele_ico} alt="Ashlok Safe Earthing Electrode showcasing innovative earthing solutions for safe electrical grounding"/></div>
                <div  className=''><p className=' text-base text-white'>Safe Earthing Electrode(s)</p></div>
            </div>
            <div className={`w-full lg:w-1/5 h-18 flex flex-row  justify-start  lg:justify-center items-center  ml-1 mr-1 cursor-pointer hover:cursor-pointer ${selectedItem === 'bfc'  ? 'bg-ashred' : ''}`} onClick={() => handleItemClick('bfc')}>
                <div  className='h-20 flex items-center px-4 w-14'><Image src={bfc_ico} alt="Comprehensive Range of Backfill Compounds for Earthing Protection - Ashlok Safe Earthing Electrode Limited"/></div>
                <div  className=''><p className=' text-base text-white'>BackFil Compound(s)</p></div>
                
            </div>
            <div className={`w-full lg:w-1/5 h-18 flex flex-row  justify-start  lg:justify-center items-center  ml-1 mr-1 cursor-pointer hover:cursor-pointer ${selectedItem === 'epcc'  ? 'bg-ashred' : ''}`} onClick={() => handleItemClick('epcc')}>
                <div  className='h-20 flex items-center justify-start px-4 w-14'><Image src={epcc_ico} className=' ' alt="Earth Pit Chamber Cover Ashlok Safe Earthing Electrodes and Chamber Cover Manufacturer & Supplier"/></div>
                <div  className=''><p className=' text-base text-white'>EarthPit Chamber Cover(s)</p></div>
            </div>

        </div>
      
    </div>
  )
}

export default ProductsubMenu
